import PropTypes from 'prop-types'
import { motion, useScroll, useSpring } from 'framer-motion'
import { NavBar } from './NavBar'
import { useTheme } from '../../contexts/ThemeContext'
import { MouseSpotlight } from '../ui/FloatingElement'

export const MainLayout = ({ children }) => {
  const { isDark } = useTheme()
  const { scrollYProgress } = useScroll()
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 })

  return (
    <div className={`
      min-h-screen transition-colors duration-300
      ${isDark 
        ? 'text-neutral-100' 
        : 'text-neutral-900'
      }
    `}>
      {/* Cursor spotlight */}
      <MouseSpotlight />
      {/* Scroll progress bar — accent glow */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-[2px] origin-left z-[60]"
        style={{
          scaleX,
          background: 'linear-gradient(90deg, #14b8a6, #38bdf8, #14b8a6)',
          boxShadow: '0 0 8px rgba(20,184,166,0.5)',
        }}
      />
      <NavBar />
      <main className="relative pt-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.div>
      </main>
    </div>
  )
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired
}